import axios from 'axios';
import { serverConfig } from './server-config';

let getDomainFromAddressBar = () => {
  // Get the current URL from the address bar
  const currentURL = window.location.href;

  // Create a URL object from the URL string
  const url = new URL(currentURL);

  // Extract and return the domain (host) from the URL
  return url.hostname;
};

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Auth token has expired or is invalid, delete it from local storage
      localStorage.removeItem('authToken');
      if (window.location.pathname !== '/login') {
        location.reload();
      }
    }
    return Promise.reject(error);
  }
);
export const CandidateService = {
  login: (usernameOrEmail, password, newPassword, confirmPassword, token) => {
    return axios.post(`https://${serverConfig.serverBaseAddress}/signite/auth/token`, {
      usernameOrEmail,
      password,
      newPassword,
      confirmPassword,
      token,
    });
  },
  logout: () => {
    const token = localStorage.getItem('authToken');
    return axios.get(`https://${serverConfig.serverBaseAddress}/signite/auth/logout`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
  },

  sendOtp: (usernameOrEmail) => {
    return axios.post(`https://${serverConfig.serverBaseAddress}/signite/auth/forgot-password/send-otp?usernameOrEmail=${usernameOrEmail}`);
  },

  verifyOtp: (usernameOrEmail, otp) => {
    return axios.post(`https://${serverConfig.serverBaseAddress}/signite/auth/forgot-password/verify-otp`, {
      usernameOrEmail,
      otp,
    });
  },

  resetPassword: (usernameOrEmail, otp, newPassword, confirmPassword) => {
    return axios.post(`https://${serverConfig.serverBaseAddress}/signite/auth/forgot-password/reset`, {
      usernameOrEmail,
      otp,
      newPassword,
      confirmPassword,
    }
    );
  },

  getAllCandidates: (
    pageIndex,
    pageSize,
    firstName = '',
    lastName = '',
    assignedToUsername = '',
    isAssigned = null
  ) => {
    let query = `?page=${pageIndex || 0}&size=${pageSize || 10}&firstName=${firstName}&lastName=${lastName}`;

    if (assignedToUsername && assignedToUsername.trim() !== '') {
      query += `&assignedToUsername=${assignedToUsername}`;
    }

    if (isAssigned !== null) {
      query += `&isAssigned=${isAssigned}`;
    }

    return axios.get(
      `https://${serverConfig.serverBaseAddress}/signite/candidate/get/all-candidates${query}`,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },


  searchCandidates: (query) => {
    http: return axios.get(
      `https://${serverConfig.serverBaseAddress}/signite/candidate/search/by-first-last-names?firstName=${query.firstName}&lastName=${query.lastName}&page=${query.pageIndex}&size=${query.pageSize}`,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },

  getCandidateById: (candidateId) => {
    return axios.get(`https://${serverConfig.serverBaseAddress}/signite/candidate/` + candidateId, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      },
    });
  },

  addCandidate: async (candidateData) => {
    return axios.post(`https://${serverConfig.serverBaseAddress}/signite/candidate/add`, candidateData, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      },
    });
  },

  updateCandidate: async (candidateData, section) => {
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/candidate/update/submit?section=` + section,
      candidateData,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },
  saveCandidate: async (candidateData, section) => {
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/candidate/update/save?section=` + section,
      candidateData,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },
  uploadFileV2: (formData, candidateId, fileType, onSuccess, setLoader) => {
    setLoader && setLoader(true);
    axios
      .post(`https://${serverConfig.serverBaseAddress}/signite/candidate/upload/file?docType=${fileType}&candidateId=${candidateId}`, formData, {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response1) => {
        setLoader && setLoader(false);
        onSuccess(response1.data);

      })
      .catch((error) => {
        console.error(error);
        setLoader && setLoader(false);
      });
  },
  uploadFile: (formData, fileType, onSuccess, setLoader) => {
    setLoader && setLoader(true);
    axios
      .post(`https://${serverConfig.serverBaseAddress}/signite/file/upload?type=${fileType}`, formData, {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response1) => {
        setLoader && setLoader(false);
        onSuccess(response1.data);

      })
      .catch((error) => {
        console.error(error);
        setLoader && setLoader(false);
      });
  },
  uploadDp: (formData, candidateId, onSuccess, setLoader) => {
    setLoader(true);
    axios
      .post(`https://${serverConfig.serverBaseAddress}/signite/candidate/upload/file?docType=CANDIDATE_DP&candidateId=${candidateId}`, formData, {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response1) => {
        const headers = new Headers();
        headers.append('Authorization', 'Bearer ' + localStorage.getItem('authToken'));

        const imageUrl = URL.createObjectURL(b64toBlob(response1.data.file, 'image/jpeg', 512));
        onSuccess({
          blob: imageUrl,
          fileHandle: { originalName: response1.data.originalName, path: response1.data.path },
        });
        setLoader(false);
      })
      .catch((error) => {
        console.error(error);
        setLoader(false);
      });
  },
  getAuthHeader: () => ({ Authorization: 'Bearer ' + localStorage.getItem('authToken') }),
  getAllCallingCodes: () => {
    return axios.get(`https://${serverConfig.serverBaseAddress}/signite/data/calling-codes`, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      },
    });
  },

  removeFile: (file) => {
    return axios.delete(`https://${serverConfig.serverBaseAddress}/signite/file/delete?path=${file}`, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      },
    });
  },

  setSearchableStatus: (candidateId, searchStatus, setLoader) => {
    setLoader(true);
    return axios
      .post(
        `https://${serverConfig.serverBaseAddress}/signite/internal-user-actions/modify-search-status?candidateId=${candidateId}&searchStatus=${searchStatus}`,
        {},
        {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('authToken'),
            'Content-Type': 'application/json',
          },
        }
      )
  },

  setCallStatus: (candidateId, callStatus, setLoader) => {
    setLoader(true);
    axios
      .post(
        `https://${serverConfig.serverBaseAddress}/signite/internal-user-actions/modify-call-status?candidateId=${candidateId}&callStatus=${callStatus}`,
        {},
        {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('authToken'),
            'Content-Type': 'application/json',
          },
        }
      )
      .then((response1) => {
        alert('Candidate call status updated!');
        setLoader(false);
      })
      .catch((error) => {
        alert(`Error occured while updating candidate call status : ${error.message}`);
        console.error(error);
        setLoader(false);
      });
  },
  downloadResume: (resumePath) => {
    return axios({
      method: 'get',
      url: `https://${serverConfig.serverBaseAddress}/signite/file/download?path=${resumePath}`,
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
      },
    });
  },

  downloadFile: (type, filePath) => {
    return axios({
      method: 'get',
      url: `https://${serverConfig.serverBaseAddress}/signite/file/download?type=${type}&path=${filePath}`,
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
      },
    });
  },


  getTLUnapprovedApprovalRequestedCandidates: async (
    candidateApproved,
    searchStatus,
    validationStatus,
    page,
    size
  ) => {
    const queryParams = new URLSearchParams();

    if (candidateApproved?.trim()) queryParams.append('candidateApproved', candidateApproved);
    if (searchStatus?.trim()) queryParams.append('searchStatus', searchStatus);
    if (validationStatus?.trim()) queryParams.append('validationStatus', validationStatus);

    queryParams.append('page', page.toString());
    queryParams.append('size', size.toString());

    const url = `https://${serverConfig.serverBaseAddress}/signite/internal-user-actions/get/tl-unapproved-approval-requested-candidates?${queryParams.toString()}`;

    return axios.get(url, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      },
    })
      .then(response => response)
      .catch(error => {
        console.error('Error fetching TL candidates:', error);
        if (error.response?.status === 401) {
          localStorage.removeItem('authToken');
          location.reload();
        }
        return Promise.reject(error);
      });
  },

  approveCandidateRequest: async (candidateId) => {
    const url = `https://${serverConfig.serverBaseAddress}/signite/internal-user-actions/approve-candidate`;
    return axios.post(url, null, {
      params: { candidateId },
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      },
    })
      .then(response => response)
      .catch(error => {
        console.error("Error in requestCandidateApproval API call:", error);
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('authToken');
          location.reload();
        }
        return Promise.reject(error);
      });
  },

  
  requestCandidateApproval: async (candidateId) => {
    const url = `https://${serverConfig.serverBaseAddress}/signite/internal-user-actions/request-candidate-approval`;
    return axios.post(url, null, {
      params: { candidateId },
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      },
    })
      .then(response => response)
      .catch(error => {
        console.error("Error in requestCandidateApproval API call:", error);
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('authToken');
          location.reload();
        }
        return Promise.reject(error);
      });
  },

  candidatePostLoginPasswordReset: (usernameOrEmail, password, newPassword, confirmPassword, token) => {
    return axios.post(`https://${serverConfig.serverBaseAddress}/signite/auth/reset-password`, {
      usernameOrEmail,
      password,
      newPassword,
      confirmPassword,
      token,
    }
    );
  },

  getNotificationBatches: (pageNo = 0, pageSize = 10) => {
    return axios.get(
      `https://${serverConfig.serverBaseAddress}/signite/admin/get-job/batches`,
      {
        params: {
          pageNo,
          pageSize,
        },
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },

  acceptTerms: () => {
    const token = localStorage.getItem('authToken');

    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/candidate/terms-and-conditions/accept`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );
  },

  declineTerms: () => {
    const token = localStorage.getItem('authToken');

    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/candidate/terms-and-conditions/decline`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );
  },

};

const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
};

export const decodeJWT = (token) => {
  if (token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace('-', '+').replace('_', '/');
    return JSON.parse(atob(base64));
  } else {
    return { roles: '' };
  }
};